export const TIER_SWITCH_BLOCKED_REASON = {
	TIER_CHANGE_PENDING: 'TIER_CHANGE_PENDING',
	HAS_ACTIVE_TERMED_VOUCHER: 'HAS_ACTIVE_TERMED_VOUCHER',
	RESELLER_EXCLUDED_FROM_SWITCHING: 'RESELLER_EXCLUDED_FROM_SWITCHING',
	SUBSCRIPTION_CANCELLED: 'SUBSCRIPTION_CANCELLED',
	TOO_EARLY_TO_SWITCH: 'TOO_EARLY_TO_SWITCH',
	IS_TRUSTED_PARTY_SUBSCRIPTION: 'IS_TRUSTED_PARTY_SUBSCRIPTION',
	IS_IN_PERIOD_WITH_FIXED_TIER: 'IS_IN_PERIOD_WITH_FIXED_TIER',
	SWITCH_NOT_ALLOWED: 'SWITCH_NOT_ALLOWED',
};

export const TIER_SWITCH_TYPES = {
	ALLOWED_TIER_SWITCH: 'AllowedTierSwitch',
	BLOCKED_TIER_SWTICH: 'BlockedTierSwitch',
};
